/* Fransk katalog for locale-firm-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('fr', {
  'rf.loading.firm': 'Chargement de votre cabinet …',
  'rf.loading.clients': 'Récupération de vos clients …',
  'rf.loading.reconciliation': 'Récupération des rapprochements …',
  'rf.loading.control': 'Récupération des tâches de contrôle …',
  'rf.loading.ledger': 'Chargement de la comptabilité du client …',
  'rf.pageError.title': 'La page n’a pas pu être chargée',
  'rf.pageError.text': 'Rechargez l’espace cabinet. Si le problème persiste, le script de cette page est indisponible.',
  'rf.client.assignCount': 'Affecter ({count})',
  'rf.client.assignAll': 'Tout le cabinet',
  'rf.client.assignNobody': 'Le cabinet n’a pas encore de collaborateurs actifs à affecter à la mission.',
  'rf.client.assignRoleHint': 'Le rôle s’applique à toutes les personnes cochées. Celles déjà affectées reçoivent le nouveau rôle.',
  'rf.client.assignedMany': '{count} collaborateurs ont été affectés à la mission',
  'rf.nav.myPage': 'Mon espace',
  'rf.nav.firmBooks': 'Vers la comptabilité du cabinet',
});
